import React, { FC } from 'react';
import ArrowCard from 'assets/img/campanhas-de-marketing/arrow-card.svg';
import { CampaignCardsProps } from 'models/campaign-mkt';
import { campaignProfiles } from 'utils/campanha-utils';
import * as S from './style';

const CampaignCards: FC<CampaignCardsProps> = ({ onCreateCampaign }) => (
  <S.Container>
    {campaignProfiles.map(({ audience, title, description, image }) => (
      <S.Card key={title}>
        <S.Image src={image} alt="" />
        <S.Content>
          <S.Title>{title}</S.Title>
          <S.Description>{description}</S.Description>
          <S.Button type="button" onClick={() => onCreateCampaign(audience)}>
            Criar campanha
            <S.ButtonIcon src={ArrowCard} alt="" />
          </S.Button>
        </S.Content>
      </S.Card>
    ))}
  </S.Container>
);

export default CampaignCards;
